/* eslint-disable linebreak-style */
/* eslint-disable camelcase */
/* eslint-disable no-plusplus */
import { Component, createElement } from 'react';

import * as prodLytics from './analytics/prod';
import * as devLytics from './analytics/dev';

function isLocal() {
  return window.location.hostname === 'localhost';
}

function isDev() {
  return process.env.NODE_ENV !== 'production';
}

function isExcluded(exclude) {
  const { pathname } = window.location;

  return exclude.some((item) => pathname.match(item));
}

const withFBQ = (codes, { router } = {}, { localhost = 'localhost', exclude = [] } = {}) => (Page) => {
  class WithFacebookPixel extends Component {
    constructor(props) {
      super(props);
      this.state = {
        fbp: undefined
      };
    }

    componentDidMount() {
      if (!isExcluded(exclude)) {
        const shouldNotTrack = isLocal(localhost) || isDev();
        const fbp = shouldNotTrack ? devLytics : prodLytics;
        fbp.init(codes);

        fbp.pageview();

        // listen route changes
        if (router && router.events && typeof router.events.on === 'function') {
          router.events.on('routeChangeComplete', () => {
            fbp.pageview();
          });
        }

        this.setState({
          fbp
        });
      }
    }

    render() {
      return createElement(Page, {
        ...this.props,
        fbp: this.state.fbp
      });
    }
  }

  return WithFacebookPixel;
};

export default withFBQ;
